import { computed } from "vue";
import orderBy from "lodash.orderby";
import deepEqual from "fast-deep-equal";
import store from "@/store";
import FILTER_RULES, { FILTER_IS_TOP } from "@/constants/filterRules";

export default () => {
  const currentFilter = computed(() => {
    // @ts-ignore
    const { filterId } = store.state.route.query;
    return store.getters["filters/getFilterById"](filterId);
  });

  const filterRules = computed(
    // @ts-ignore
    () => store.state.filterRules.filterRules as any[]
  );

  const isSaveSearchButtonActivated = computed(() => {
    // NB: need to map "exclude" property if it is not present as it may
    // conflict with filterRules retrieved from the api
    const mapExclude = rule => {
      const r = { ...rule };
      if (r.exclude === undefined) {
        r.exclude = false;
      }
      return r;
    };

    // NB: Need to delete the "truncate" property if it is present and
    // undefined as it may conflict with pre-existent filterRules
    const mapTruncate = rule => {
      const r = { ...rule };
      if (r.truncate === undefined) {
        delete r.truncate;
      }
      return r;
    };

    if (!currentFilter.value && !filterRules.value.length) {
      return false;
    }

    const defaultFilterRules = () => [
      {
        type: FILTER_IS_TOP.name,
        values: ["true"]
      }
    ];

    const currentFilterRules = orderBy(
      currentFilter.value
        ? [...currentFilter.value.filterRules]
        : defaultFilterRules(),
      ({ type }) => {
        if (FILTER_RULES[type]) {
          return FILTER_RULES[type].weight;
        }
        return 100;
      }
    )
      .map(mapExclude)
      .map(mapTruncate);

    const appliedFilterRules = orderBy(
      [...(filterRules.value || [])],
      ({ type }) => {
        if (FILTER_RULES[type]) {
          return FILTER_RULES[type].weight;
        }
        return 100;
      }
    )
      .map(mapExclude)
      .map(mapTruncate);

    return (
      !deepEqual(currentFilterRules, appliedFilterRules) &&
      // @ts-ignore
      !store.state.route.query.filterCombination
    );
  });

  const showFilterDialog = computed({
    get() {
      // @ts-ignore
      return store.state.ui.showFilterDialog;
    },
    set(newValue) {
      store.commit("ui/setShowFilterDialog", newValue);
    }
  });

  const setShowFilterDialog = value => {
    store.commit("ui/setShowFilterDialog", value);
  };

  return {
    currentFilter,
    isSaveSearchButtonActivated,
    showFilterDialog,
    setShowFilterDialog
  };
};
